export const WORKFLOW_FORWARD = 'FORWARD'
export const WORKFLOW_BACKWARD = 'BACKWARD'
